"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = exports.IconSize = void 0;
var preact_1 = require("preact");
var classnames = require("classnames");
var icons_1 = require("./icons");
var styles = require("./icon.scss");
var IconSize;
(function (IconSize) {
    IconSize["small"] = "small";
    IconSize["medium"] = "medium";
    IconSize["large"] = "large";
})(IconSize = exports.IconSize || (exports.IconSize = {}));
var Icon = function (props) {
    var Icon = icons_1.Icons[props.name];
    if (!Icon) {
        return null;
    }
    return ((0, preact_1.h)("div", { className: classnames(styles.iconWrapper, styles[props.size]) },
        (0, preact_1.h)(Icon, null)));
};
exports.Icon = Icon;
exports.Icon.defaultProps = {
    size: IconSize.medium
};
//# sourceMappingURL=index.js.map